<template>
<section class="content_wrap archive_wrap two_line_clm">
  <h2 v-if="sectionName">{{ this.sectionName }}</h2>
  <div class="archive">
      <div v-for="item in items" :key="item.id" class="post_clm">
        <a href="#" @click.prevent="showModal($event, item.social_id + item.user_id + hashtag)" :class="item.social_name">
          <div class="img_box" v-if="item.image !== null">
            <img :src="'/storage/' + item.image" alt="" />
          </div>
          <div class="img_box" v-else-if="item.customer_image_thumbnail !== null">
            <img :src="'/storage/customers/' + item.customer_image_thumbnail" alt="" />
          </div>
          <div class="img_box" v-else>
            <img src="/assets/img/common/no_image.png" alt="no image" />
          </div>
          <div class="txt_box">
            <h3 class="height_align">{{ item.title | truncate }}</h3>
              <p class="salon_name">{{ item.juristic_name }}</p>
              <p class="distance">&nbsp;</p>
          </div>
        </a>
      </div>
  </div>

  <div v-for="item in items" :key="item.id">
    <modal :name="item.social_id + item.user_id + hashtag" :adaptive="true" width="94%" height="auto" :max-width="400" >
        <div class="modal_box">
          <a :href="item.permalink" :class="'social_link ' + item.social_name" target="_blank" :data-sns="item.social_name" :data-juristicname="item.juristic_name">
              <div class="img_box" v-if="item.image !== null">
                <img :src="'/storage/' + item.image" alt="" />
              </div>
              <div class="img_box" v-else-if="item.customer_image_thumbnail !== null">
                <img :src="'/storage/customers/' + item.customer_image_thumbnail" alt="" />
              </div>
              <div class="img_box" v-else>
                <img src="/assets/img/common/no_image.png" alt="no image" />
              </div>
              <div class="txt_box">
                <nl2br tag="p" :text="item.title | truncate(100)" class="sns_text"></nl2br>
                <p class="salon_name">{{ item.juristic_name }}</p>
                <p class="distance">&nbsp;</p>
              </div>
          </a>
        </div><!-- /.modal_box --> 
        <a href="#" @click.prevent="hideModal($event, item.social_id + item.user_id + hashtag)" class="close_btn">閉じる</a>
    </modal>
  </div>
  <div v-show="hasMessage" class="message">
    {{ this.message }}
  </div>
  <div class="spinner_area">
    <beat-loader :loading="isLoading" :color="'#ff6969'" :size="'12px'"></beat-loader>
  </div>
  <a v-if="moreBtn" id="more_btn" class="btn small_btn" @click="getPosts()">もっと見る</a>
</section>
</template>

<script>
export default {
  // 初期値設定
  data() {
    return {
      sectionName: null,
      isPage:false,
      total_count: 0,
      items: [],
      requested: false,
      startPost:0,
      moreBtn: true,
      hasMessage: false,
      message: '',
      isLoading: false
    };
  },
  props: {
    itemName: {
      type:String,
      default:"",
    },
    itemType: {
      type:String,
      default:"",
    },
    type: String,
    hashtag: {
      type:String,
      default:"",
    },
    pref: String,
    keyword: String,
    userId: Number,
    socialType: Number,
    socialIndex: Number,
    limit: Number
  },
  methods: {
    getPosts() {
      this.isLoading = true;
      if(this.itemName) {
        this.sectionName = this.itemName + this.itemType;
      }
      const data = {
        type: this.type,
        tag: this.hashtag,
        pref: this.pref,
        social_type: this.socialType,
        social_index: this.socialIndex,
        keyword: this.keyword,
        limit: this.limit,
        offset: this.startPost
      };
      var self = this;
      axios
        .post("/api/posts-official", data)
        // 成功時処理
        .then(res => {
          self.requested = true;
          self.isLoading = false;
          self.items = self.items.concat(res.data.items);
          if (self.items.length > 0) {
            // 全レコード数を取得
            self.total_count = self.items[0].total_count;
          }
          self.startPost = Object.keys(self.items).length;
          if(self.total_count <= self.startPost) {
            // もっと見るボタン非表示にする
            self.moreBtn = false;
          }
          this.showMessages();
        })
        // エラーレスポンス時処理
        .catch(error => {
          self.requested = true;
          self.isLoading = false;
          console.log(error);
          this.showMessages();
        });
    },
    showMessages() {
      // データが見つからない場合のメッセージ表示
      if (this.requested && this.total_count === 0) {
        this.message = '条件に合うデータが見つかりませんでした。';
        this.hasMessage = true;
      }
    },
    showModal(e, modalId) {
      this.$modal.show(modalId);
    },
    hideModal(e, modalId) {
      this.$modal.hide(modalId);
    }
  },
  created() {
    this.getPosts();

    if(this.userId) {
      this.isPage = true;
    }
  },
  updated() {
    this.$nextTick(function() {
      // 以下高さを揃える処理
      const nodes = document.getElementsByClassName('height_align')
      let maxHeight = '0px'
      // 各要素の高さを取得
      for (let i = 0; i < nodes.length; i++) {
        const height = window.getComputedStyle(nodes[i]).height
        if (maxHeight < height) {
          maxHeight = height
        }
      }
      // 一番高いやつに高さを合わせる
      for (let i = 0; i < nodes.length; i++) {
        nodes[i].style.height = maxHeight
      }

      // サロン名の高さも揃える
      const salonName = document.getElementsByClassName('salon_name')
      let salonNameHeight = '0px'
      for (let i = 0; i < salonName.length; i++) {
        const height = window.getComputedStyle(salonName[i]).height
        if (salonNameHeight < height) {
          salonNameHeight = height
        }
      }
      for (let i = 0; i < salonName.length; i++) {
        salonName[i].style.height = salonNameHeight
      }
    });
  }
};
</script>